// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"67aa4a06","239":"e78ad9fb","553":"66bd0dca"}[chunkId] + ".chunk.js";
};